import React from 'react';
import logo from '../../assets/logo/vulli_narayana_tuitions_logo.png';
import { 
  InstagramOutlined, 
  FacebookOutlined, 
  TwitterOutlined, 
  MailOutlined, 
  PhoneOutlined, 
  EnvironmentOutlined 
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container footer-grid">
        
        {/* Brand Section */}
        <div className="footer-brand">
          <Link to="/" onClick={() => window.scrollTo(0, 0)}>
            <img 
              src={logo} 
              className='footer-logo' 
              alt='Narayana Tuitions' 
              style={{ cursor: 'pointer' }} 
            />
          </Link>
          <p>
            Tirupati's premier destination for academic excellence. 
            Empowering students with foundational mastery and 21st-century 
            skills since 2014.
          </p>
          <div className="footer-socials">
            <a href="https://instagram.com" target="_blank" rel="noreferrer"><InstagramOutlined /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer"><FacebookOutlined /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer"><TwitterOutlined /></a>
          </div>
        </div>

        {/* Centers Section */}
        <div className="footer-links">
          <h4>Our Centers</h4>
          <ul>
            <li>
              <EnvironmentOutlined /> 
              <span>Bhavani Nagar, Main Branch, Tirupati</span>
            </li>
            <li>
              <EnvironmentOutlined /> 
              <span>MR Palli, Branch Office, Tirupati</span>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-contact">
          <h4>Get In Touch</h4>
          <div className="contact-item">
            <MailOutlined />
            <a href="mailto:vullinarayanatuitions@gmail.com">vullinarayanatuitions@gmail.com</a>
          </div>
          <div className="contact-item">
            <PhoneOutlined />
            <a href="tel:9700213084">9700213084</a>
          </div>
          <div className="contact-item">
            <PhoneOutlined />
            <a href="tel:9666560350">9666560350</a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="container bottom-flex">
          <p>&copy; 2026 Vulli Narayana Tuitions. All Rights Reserved.</p>
          
          {/* Credit Link */}
          <p className="bixian-credit">
            Designed by <a href="https://bixianperformancemarketing.com" target="_blank" rel="noreferrer">Bixian Performance Marketing</a>
          </p>

          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            {/* <a href="#terms">Terms of Service</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;